import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_CAMPAIGN: 'FETCH_CAMPAIGN',
  RESET: 'RESET',
}

const fetchReset = async (state) => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetch = async (state, campaign) => {
  state = {
    ...state,
    isStatus: campaign.status,
    expireToken: sanitizeExpire({
      status: campaign.status,
      data: campaign.data,
      name: 'campaignobj',
    }),
    data: sanitizeData({
      status: campaign.status,
      data: campaign.data,
      name: 'campaignobj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CAMPAIGN:
      return fetch(state, action.campaign)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const campaign = {
  init,
  actionTypes,
  reducer,
}

export default campaign
